import React, { SVGProps } from "react";

const FillStarIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.33496 10.8363C2.02171 10.5466 2.19187 10.0229 2.61557 9.97267L8.61914 9.26058C8.79182 9.2401 8.94181 9.13166 9.01465 8.97376L11.5469 3.48397C11.7256 3.09654 12.2764 3.09646 12.4551 3.4839L14.9873 8.97365C15.0601 9.13155 15.2092 9.24028 15.3818 9.26075L21.3857 9.97267C21.8094 10.0229 21.9791 10.5468 21.6659 10.8364L17.2278 14.9414C17.1001 15.0595 17.0433 15.2352 17.0771 15.4058L18.255 21.3355C18.3382 21.7539 17.8928 22.0782 17.5205 21.8698L12.2451 18.9161C12.0934 18.8312 11.9091 18.8316 11.7573 18.9165L6.48144 21.869C6.10913 22.0774 5.66294 21.7539 5.74609 21.3354L6.92414 15.4061C6.95803 15.2356 6.90134 15.0594 6.77367 14.9414L2.33496 10.8363Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FillStarIcon;
